import { deleteCoreApiGatewayKeysByIdSlice } from './delete';
import { patchCoreApiGatewayKeysByIdSlice } from './patch';

export const { requestDeleteCoreApiGatewayKeysById, resetDeleteCoreApiGatewayKeysById } =
	deleteCoreApiGatewayKeysByIdSlice.asyncActionCreators;

export const { requestPatchCoreApiGatewayKeysById, resetPatchCoreApiGatewayKeysById } =
	patchCoreApiGatewayKeysByIdSlice.asyncActionCreators;
